
export const Constants = {
  public: {
    Enums: {
      app_role: ["admin", "business_owner"],
    },
  },
};

/**
 * Example structure of tables (for documentation / reference)
 * Supabase will still enforce row/insert/update on the backend.
 */
export const Database = {
  public: {
    Tables: {
      businesses: {
        Row: {
          id: "",
          name: "",
          owner_id: "",
          industry: "",
          address: null,
          description: null,
          email: null,
          phone: null,
          status: null,
          website_url: null,
          created_at: null,
          updated_at: null,
        },
        Insert: {
          id: undefined,
          name: "",
          owner_id: "",
          industry: "",
          address: undefined,
          description: undefined,
          email: undefined,
          phone: undefined,
          status: undefined,
          website_url: undefined,
          created_at: undefined,
          updated_at: undefined,
        },
        Update: {
          id: undefined,
          name: undefined,
          owner_id: undefined,
          industry: undefined,
          address: undefined,
          description: undefined,
          email: undefined,
          phone: undefined,
          status: undefined,
          website_url: undefined,
          created_at: undefined,
          updated_at: undefined,
        },
        Relationships: [],
      },
      generated_content: {
        Row: {
          id: "",
          business_id: "",
          script: "",
          content_type: "",
          title: null,
          goal: null,
          cta: null,
          hashtags: null,
          clicks: null,
          leads_generated: null,
          status: null,
          created_at: null,
        },
        Insert: {
          id: undefined,
          business_id: "",
          script: "",
          content_type: "",
          title: undefined,
          goal: undefined,
          cta: undefined,
          hashtags: undefined,
          clicks: undefined,
          leads_generated: undefined,
          status: undefined,
          created_at: undefined,
        },
        Update: {
          id: undefined,
          business_id: undefined,
          script: undefined,
          content_type: undefined,
          title: undefined,
          goal: undefined,
          cta: undefined,
          hashtags: undefined,
          clicks: undefined,
          leads_generated: undefined,
          status: undefined,
          created_at: undefined,
        },
        Relationships: [
          {
            foreignKeyName: "generated_content_business_id_fkey",
            columns: ["business_id"],
            isOneToOne: false,
            referencedRelation: "businesses",
            referencedColumns: ["id"],
          },
        ],
      },
      // Repeat similar for leads, profiles, reviews, user_roles...
    },
    Views: {},
    Functions: {
      has_role: {
        Args: {
          _role: "admin" || "business_owner",
          _user_id: "",
        },
        Returns: true, // just for reference
      },
    },
    Enums: {
      app_role: ["admin", "business_owner"],
    },
    CompositeTypes: {},
  },
};
